import { render } from "./OnboardingCard.vue?vue&type=template&id=13f7f4fe&scoped=true"
import script from "./OnboardingCard.vue?vue&type=script&lang=js"
export * from "./OnboardingCard.vue?vue&type=script&lang=js"

import "./OnboardingCard.vue?vue&type=style&index=0&id=13f7f4fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f7f4fe"]])

export default __exports__